import { ExpandableCard } from "../../components";
import { ContractorMetrics } from "@/api/williams/contractors";
import { useContractorMetrics } from "../hooks";

import styles from "./Metrics.tsx.module.css";

export function Metrics({ contractorId }: { contractorId: string }) {
  const metrics = useContractorMetrics(contractorId);

  return (
    <ExpandableCard caption="Metrics">
      {metrics.isLoading ? (
        <p>Loading...</p>
      ) : metrics.isError ? (
        <p>An unknown error occurred.</p>
      ) : metrics.isSuccess ? (
        <MetricsTable metrics={metrics.data} />
      ) : (
        <p>No metrics found.</p>
      )}
    </ExpandableCard>
  );
}

function MetricsTable({ metrics }: { metrics: ContractorMetrics }) {
  return (
    <ul className={styles.fieldList}>
      <li>
        <label>Welders Tested</label>
        <span>{metrics.weldersTested}</span>
      </li>
      <li>
        <label>Welder Tests</label>
        <span>{metrics.welderTests}</span>
      </li>
      <li>
        <label>API 1104 Tests</label>
        <span>{metrics.api1104Tests}</span>
      </li>
      <li>
        <label>ASME IX Tests</label>
        <span>{metrics.asmeTests}</span>
      </li>
      <li>
        <label>In-service Tests</label>
        <span>{metrics.inServiceTests}</span>
      </li>
      <li>
        <label>Tests Passed</label>
        <span>{metrics.testsPassed}</span>
      </li>
      <li>
        <label>Tests Failed</label>
        <span>{metrics.testsFailed}</span>
      </li>
      <li>
        <label>Pass Rate</label>
        <span>{Math.round(metrics.passRate)}%</span>
      </li>
    </ul>
  );
}
